<template>
  <div>
    <TplListBasic :title="title(routeName)">
      <template v-slot:sheet-tags>
        <div class="tags-container" v-if="!isNew">
          <el-tag type="success" v-if="xeroSent=='Sent'" size="medium">Xero {{xeroSent}}</el-tag>
          <el-tag type="danger" v-if="xeroSent=='Fail'" size="medium">Xero {{xeroSent}}</el-tag>
          <el-tag
            type="warning"
            v-if="xeroSent!=='Fail'&&xeroSent!=='Sent'"
            size="medium"
          >Xero {{xeroSent}}</el-tag>
        </div>
      </template>
      <template v-slot:actions>
        <div class="actions-btns-container">
          <div class="actions-btns-container">
            <el-button type="primary" class="btn" @click="handleSubmit">Submit</el-button>
          </div>
        </div>
      </template>
      <template v-slot:search>
        <BaseInfoInputs :isEdit="true" :config="config" :routeName="routeName" />
      </template>
    </TplListBasic>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import TplListBasic from '../components/TplListBasic'
import BaseInfoInputs from '../components/BaseInfoInputs'
import { routeInfoPRDC, routeInfoCSR } from '../router'
import { Message } from 'element-ui'
export default {
  name: 'BaseInfoAdd',
  components: {
    TplListBasic,
    BaseInfoInputs
    // CartSimple
  },
  created () {
    this.routeName = this.$route.params.routeName
    const id = this.$route.params.id || 0

    if (id > 0) {
      this.isNew = false
      this.initEdit({ routeName: this.routeName, id })
    } else {
      this.isNew = true
      this.initAdd(this.routeName)
    }
  },
  data () {
    return {
      // bus: new Vue(),
      routeName: '',
      isNew: true
    }
  },
  computed: {
    ...mapState('config', {
      config: 'inputs'
    }),
    ...mapState('baseinfo', {
      xeroSent: 'xeroSent'
    }),
    ...mapGetters({
      title: 'prefs/getPageTitle'
    })
  },
  methods: {
    ...mapActions({
      submitProduct: 'baseinfo/submitProduct',
      submitCsr: 'baseinfo/submitCsr',
      initAdd: 'baseinfo/initAdd',
      initEdit: 'baseinfo/initEdit'
    }),
    handleSubmit () {
      switch (this.routeName) {
        case routeInfoPRDC:
          this.submitProduct().then(data => {
            if (data) {
              this.success(data.id)
            }
          })
          break
        case routeInfoCSR:
          this.submitCsr().then(data => {
            this.success(data.id)
          })
          break
      }
    },
    success (id) {
      this.$message({
        message: 'Operation successful',
        type: 'success'
      })
      this.isNew = false
      this.initEdit({ routeName: this.routeName, id })
    },
    handleCancel () {
      this.$router.back()
    }
  },
  beforeRouteEnter (to, from, next) {
    const orgId = Number.parseInt(localStorage.getItem('orgId') || 0)
    const roleObj = JSON.parse(localStorage.getItem('role-fone') || '{}')
    // 应david要求，墨尔本单独处理新建客户权限
    if (orgId === 4 && to.params.routeName === 'Customers') {
      if (roleObj.crtCSR) {
        next()
      } else {
        Message.warning({
          showClose: true,
          duration: 3500,
          dangerouslyUseHTMLString: true,
          message: 'Sorry, no permission to create customers. Return to list page.'
        })
        setTimeout(() => {
          next({ path: '/customers' })
        }, 1000)
      }
    } else {
      next()
    }
  },
  beforeRouteUpdate (to, from, next) {
    // just use `this`
    this.routeName = to.params.routeName
    next()
  },

  provide () {
    return {
      // bus: this.bus,
      routeName: this.routeName
    }
  }
}
</script>

<style lang="scss" scoped>
.search-area {
  background-color: #fff;
}
.list {
  margin-top: 40px;
  background-color: #ffffff;
}
.btn {
  height: 32px;
  margin-left: 12px;
  padding: 0 16px;
  line-height: 32px;
}
.actions-btns-container {
  display: flex;
  margin-right: 12px;
}

.page-wrapper {
  max-width: 1678px;
}
.viewpage-caption-container {
  display: flex;
  justify-content: space-between;
  height: 32px;
  line-height: 32px;
  margin-bottom: 12px;
}
.title {
  text-align: left;
  font-size: 18px;
  color: #939393;
  text-indent: 8px;
  font-weight: bold;
}
.search-area {
  margin-bottom: 8px;
}
.creditBgColor {
  background-color: #f9f5ec;
}
.pOrderBgColor {
  background-color: #ebf3ebda;
}
</style>
